import dayjs from 'dayjs'

import {
  ClassifiedAssistantBlock,
  ContractType,
} from '../../rest/types/Classified'

export function BlockAssistantTransformer({
  block,
  t,
}: {
  block: ClassifiedAssistantBlock
  t: any
}) {
  return {
    ...((block?.startDate || block?.endDate) && {
      adsReplacementDate: {
        title: t('ads_replacement_date_title'),
        subtitle: {
          label: block?.contract.includes(ContractType.Cdi)
            ? t('ads_replacement_date_employee_subtitle')
            : t('ads_replacement_date_replacement_subtitle'),
          requestedDate: dayjs(block?.startDate).format('DD MMMM YYYY'),
        },
        periods: {
          label: t('ads_replacement_date_period_label'),
          ...(block?.startDate && {
            start: dayjs(block?.startDate).format('DD MMMM YYYY'),
          }),
          ...(block?.endDate && {
            finish: dayjs(block?.endDate).format('DD MMMM YYYY'),
          }),
        },
      },
    }),
    ...((block?.speciality?.name || block?.cabinetType?.name) && {
      adsTypes: {
        texts: {
          seeLess: t('ads_types_see_less'),
          seeMore: t('ads_types_see_more'),
        },
        items: [
          ...(block?.speciality?.name
            ? [
                {
                  title: t('ads_types_speciality_title'),
                  text: block?.speciality?.name,
                },
              ]
            : []),

          ...(block?.cabinetType?.name
            ? [
                {
                  title: t('ads_types_cabinet_type_title'),
                  text: block?.cabinetType?.name,
                },
              ]
            : []),
        ],
      },
    }),

    adsDetailsColumn: {
      items: [
        {
          label: t('ads_details_saturday_title'),
          value: block?.saturday
            ? t('form_boolean_value_true')
            : t('form_boolean_value_false'),
        },
        ...(block?.contract?.length
          ? [
              {
                label: t('ads_details_contract_type_title'),
                values: block?.contract?.map((item) =>
                  t(`ads_details_contract_type_${item}`)
                ),
              },
            ]
          : []),
      ],
    },
    ...(block?.gestures && {
      adsDetails: {
        withColumn: false,
        items: [
          {
            label: t('ads_details_gestures_title'),
            value: block?.gestures,
          },
        ],
      },
    }),
  }
}
